<template>
    <div v-if="tags.length > 0" class="tags">
        <tag v-for="tag in tags" :name="tag.name" :color="tag.color" :key="tag.id"/>
    </div>
</template>

<script>
import Tag from '../tag/Tag.vue';

export default {
    name: 'NoteTags',
    components: { Tag },
    props: ['tags'],
};
</script>
